const getUserContext = () => {
  const customer = window.Pura?.customer

  return {
    ...(customer?.email && { email: customer.email }),
    ...(customer?.first_name && { firstName: customer.first_name }),
    ...(customer?.last_name && { lastName: customer.last_name }),
  }
}

const segment = {
  ...window.analytics,

  track: (
    event: string,
    properties: Record<string, any> = {},
    options?: Record<string, any>
  ) => {
    const enhancedProperties = {
      ...getUserContext(),
      ...properties,
    }
    return window.analytics.track(event, enhancedProperties, options)
  },

  identify: (
    traits: Record<string, any> = {},
    options?: Record<string, any>
  ) => {
    const userId = null
    const enhancedTraits = {
      ...getUserContext(),
      ...traits,
    }
    return window.analytics.identify(userId, enhancedTraits, options)
  },

  ready: (callback: () => void) => {
    return window.analytics.ready(callback)
  },

  reset: () => {
    return window.analytics.reset()
  },
}

export { segment }
export default segment
